module.exports = __webpack_public_path__ + "player2.png";